import styled from '@emotion/styled';

import { layout } from '@modernhealth/vital-foundation';
import { color } from 'src/shared/styles/variables';

export const OuterScreenWrapper = styled.div({
    backgroundColor: color.white,
    overflow: 'hidden',
    display: 'flex',
    flex: 1,
    width: '100%',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    alignItems: 'center',
    justifyContent: 'center',
});

interface ScreenWrapperProps {
    verticalCenter?: boolean;
}

export const ScreenWrapper = styled.div<ScreenWrapperProps>(({ verticalCenter = false }) => ({
    backgroundColor: color.white,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    overflowY: 'auto',
    justifyContent: verticalCenter ? 'center' : 'initial',
    maxWidth: layout.containerWidth,

    /* Hide scrollbar for IE, Edge and Firefox */
    msOverflowStyle: 'none' /* IE and Edge */,
    scrollbarWidth: 'none' /* Firefox */,

    /* Hide scrollbar for Chrome, Safari and Opera */
    '&::-webkit-scrollbar': {
        display: 'none',
    },
}));
